import { 
    BRANDKIT_INITIATE_MEDIA_UPLOAD, BRANDKIT_INVALIDATE_MEDIA_UPLOAD_ERROR, BRANDKIT_UPDATE_MEDIA_UPLOAD_PROGRESS, 
    BRANDKIT_UPLOAD_MEDIA_REQUEST, BRANDKIT_UPLOADING_MEDIA_SUCCEEDED, BRANDKIT_UPLOADING_MEDIA_FAILED,
    BRANDKIT_SEARCH_MEDIA_REQUEST, BRANDKIT_SEARCHING_MEDIA_SUCCEEDED, BRANDKIT_SEARCHING_MEDIA_FAILED, 
    BRANDKIT_DELETE_MEDIA_REQUEST, BRANDKIT_DELETING_MEDIA_SUCCEEDED, BRANDKIT_DELETING_MEDIA_FAILED, 
    BRANDKIT_INVALIDATE_MEDIA_LIBRARY, BRANDKIT_INVALIDATE_MEDIA_DELETE_ERROR
  } from 'constants/actionTypes';
  
  import { call, put, takeEvery } from 'redux-saga/effects';
  import axios from 'axios';
  import { createAction } from 'redux-actions';
  import buildUrl from 'build-url';
  
  const apiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
  const BRANDKIT_MEDIA_URL = `${apiUrl}/api/2.0/media`;
    
  /**
   * Initiate Media upload
  */
  export const initiateBrandKitMediaUpload = createAction(BRANDKIT_INITIATE_MEDIA_UPLOAD, (request) => {
    return request;
  });
  
  export const updateBrandKitMediaUploadProgress = createAction(BRANDKIT_UPDATE_MEDIA_UPLOAD_PROGRESS, (id, progress) => {
    return {id, progress};
  });
  
  export const uploadBrandKitMedia = createAction(BRANDKIT_UPLOAD_MEDIA_REQUEST, (id, request, callback) => {
    return {id, request, callback};
  })
  
  export const uploadingBrandKitMediaSucceeded = createAction(BRANDKIT_UPLOADING_MEDIA_SUCCEEDED, (id, response) => {
    return {id, response};
  })
  
  export const uploadingBrandKitMediaFailed = createAction(BRANDKIT_UPLOADING_MEDIA_FAILED, (id, error) => {
    return {id, error};
  })
  
  function* uploadBrandKitMediaSaga(action) {
    const {id, request, callback} = action.payload;
  
    const uploadBrandKitMediaAPI = () => {
      return axios.post(BRANDKIT_MEDIA_URL, request).then(response => response.data);
    }
  
    try {
      const response = yield call(uploadBrandKitMediaAPI);
      if (response) {
        yield put(uploadingBrandKitMediaSucceeded(id, response));
        if(callback) {
          callback(response);
        }
      }
    } catch (error) {
      yield put(uploadingBrandKitMediaFailed(id, error));
    }
  }
  
  
  /**
   * Search Media
   * 
  */
  export const searchBrandKitMedia = createAction(BRANDKIT_SEARCH_MEDIA_REQUEST, (request) => {
    return request;
  });
  
  const searchingBrandKitMediaSucceeded = createAction(BRANDKIT_SEARCHING_MEDIA_SUCCEEDED, (request, response) => {
    return {request, response};
  })
  
  const searchingBrandKitMediaFailed = createAction(BRANDKIT_SEARCHING_MEDIA_FAILED, (request, error) => {
    return { request, error };
  });
  
  function* searchBrandKitMediaSaga(action) {
    const request = action.payload;
  
    const fetchAllBrandKitMediaAPI = () => {
      return axios.post(`${BRANDKIT_MEDIA_URL}/search`, request).then(response => response.data);
    }
  
    try {
      const response = yield call(fetchAllBrandKitMediaAPI);
      yield put(searchingBrandKitMediaSucceeded(request, response));
    } catch (error) {
      yield put(searchingBrandKitMediaFailed(error));
    }
  }
  
  /**
   * Delete Media
   * 
  */
  export const deleteBrandKitMedia = createAction(BRANDKIT_DELETE_MEDIA_REQUEST, (ids) => {
    return ids;
  });
  
  const deleteingBrandKitMediaSucceeded = createAction(BRANDKIT_DELETING_MEDIA_SUCCEEDED, (ids, response) => {
    return { ids, response };
  })
  
  const deleteingBrandKitMediaFailed = createAction(BRANDKIT_DELETING_MEDIA_FAILED, (ids, error) => {
    return { ids, error };
  });
  
  function* deleteBrandKitMediaSaga(action) {
    const ids = action.payload;
  
    let url = buildUrl(BRANDKIT_MEDIA_URL);
  
    const deleteBrandKitMediaAPI = () => {
      return axios.delete(url, {data: ids}).then(response => response.data);
    }
  
    try {
      const response = yield call(deleteBrandKitMediaAPI);
      yield put(deleteingBrandKitMediaSucceeded(ids, response));
    } catch (error) {
      yield put(deleteingBrandKitMediaFailed(ids, error));
    }
  }
  
  /**
   * Invalidate Upload Error
  */
  export const invalidateBrandKitMediaUploadError = createAction(BRANDKIT_INVALIDATE_MEDIA_UPLOAD_ERROR);
  
  /**
   * Invalidate Media Library
   * 
  */
  export const invalidateBrandKitMediaLibrary = createAction(BRANDKIT_INVALIDATE_MEDIA_LIBRARY);
  
  
  /**
   * Delete Error
   */
  
  export const invalidateBrandKitMediaDeleteError=createAction(BRANDKIT_INVALIDATE_MEDIA_DELETE_ERROR);
  
  export default function* brandKitMediaSaga() {
    yield takeEvery(BRANDKIT_UPLOAD_MEDIA_REQUEST, uploadBrandKitMediaSaga);
    yield takeEvery(BRANDKIT_SEARCH_MEDIA_REQUEST, searchBrandKitMediaSaga);
    yield takeEvery(BRANDKIT_DELETE_MEDIA_REQUEST, deleteBrandKitMediaSaga);
  }